<tile
    title="{{ 'keywords_top_10' | translate }}"
    icon="trophy"
    change="{{keywordsTop10ChangePercentage}}"
    [showChange]="showChange"
    val="{{ keywordsTop10 | undefinedNumber }}"
    help ="{{ 'keywords_top_10_help' | translate }}">
</tile>
